<template>
  <div class="solarzaun-promo">
    <div class="promo-content">
      <div class="promo-text">
        <h3 class="custom-notification__title">
          ZAUN24 SOLARZAUN
        </h3>
        <h2>DAS LOHNT SICH!</h2>
        <button @click="scrollToWidget()" class="btn btn-primary">
          ZUM ERTRAGSRECHNER
        </button>
      </div>
      <div class="promo-graphic">
        <img v-lazy="'/assets/logo/zaun-sonne.png'" alt="Sonnengrafik mit Trend-Pfeil">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    scrollToWidget () {
      const element = document.querySelector('#solar-widget');
      if (element) {
        const offset = -100;
        const elementTop = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementTop + offset,
          behavior: 'smooth' // optional for smooth scrolling
        });
      }
    }
  }
}
</script>

<style>
.solarzaun-promo {
    background-color: #5f8dd3;
    padding: 20px;
    border-radius: 2px;
    color: white;
    margin-top: 30px;
}

.promo-content {
    display: flex;
    align-items: center;
    gap: 20px;
}

.promo-text {
    flex: 1;
}

.promo-text .btn {
    width: auto;
}

.promo-graphic {
    flex-shrink: 0;
}

.promo-graphic img {
    width: 120px;
    height: auto;
}

@media (max-width: 768px) {
    .promo-content {
        flex-direction: column;
        text-align: center;
    }
}
</style>
